import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function createLead(data) {
  return ApiRequest.fetchAdmin({
    method: "post",
    url: API_END_POINTS.CREATE_LEADS,
    data,
  }).then((response) => response.data.leads);
}